export default "assets/images/logo-whatsgoingon-0d6b0680.png";